import React from "react";
import { Placeholder } from "@bloomberg/media-ui-article";
import { createClasses } from "@bloomberg/media-ui-core";
import { CommonNode, RichText } from "@foundation/rich-text-react-renderer";
import { Block } from "@foundation/rich-text-react-renderer/lib/@types";

import defaultRichtextOptions from "~config/richtext";

import styles from "./styles.module.css";

const TEASER_BODY_SIZE = 2;

interface StoryBodyProps {
    body: CommonNode;
    options?: any;
    className?: string;
    isAllowed?: boolean;
    isLoading?: boolean;
    isBlocked?: boolean;
    storyBodyRef: React.RefObject<HTMLDivElement>;
    numberOfParagraphs?: number;
}

export const getTeaserContent = (body: CommonNode) => {
    const paragraphs = body?.content
        .filter(({ type }: Block) => type === "paragraph")
        .slice(0, TEASER_BODY_SIZE);

    return {
        ...body,
        content: paragraphs,
    };
};

const StoryBody = ({
    body,
    options = defaultRichtextOptions,
    className = "body-content",
    isAllowed,
    isLoading,
    isBlocked,
    storyBodyRef,
    numberOfParagraphs,
}: StoryBodyProps) => {
    const bodyContent = isAllowed ? body : getTeaserContent(body);
    const data = { ...bodyContent.data, numberOfParagraphs };

    return (
        <div
            ref={storyBodyRef}
            className={createClasses([
                isBlocked && styles.articleBlur,
                className,
            ])}
        >
            <RichText
                story={{ ...bodyContent, data }}
                renderers={options}
                debug
            />
            {isLoading && <Placeholder.Paragraph paragraphs={2} />}
        </div>
    );
};

export default StoryBody;
